import sessionReader from '../store/readHelpers/SessionReader';
import idVerificationService from './idverification/IdVerificationService';
import liveSessionService from './livesession/LiveSessionService';
import livestreamService from './livesession/LivestreamService';

function needsWebcam(
    isRemoteProctoringWebCamEnabled = sessionReader.isRemoteProctoringWebCamEnabled(),
) {
    return isRemoteProctoringWebCamEnabled || idVerificationService.needsIdVerification();
}

function needsAudio(
    isRemoteProctoringMicEnabled = sessionReader.isRemoteProctoringMicEnabled(),
) {
    return isRemoteProctoringMicEnabled;
}

function needsHardware(
) {
    return sessionReader.isHardwareAccessCheckEnabled();
}

/**
 * hardwareCheckIsOffline indicates if we need hardware access either:
 * - In offline mode, when identity verification needs to access the hardware
 *   but Live Proctoring is not active.
 * - In "live stream" mode, because Live Proctoring is active and it needs
 * access to hardware. Identity verification also needs access to hardware.
 *
 * Here, offline therefore means "without Live Proctoring".
 */
function hardwareCheckIsOffline() {
    return !sessionReader.supportsLivestream();
}

function hardwareCheckIsComplete(
    livestream,
    isHardwareCheckOffline = hardwareCheckIsOffline(),
) {
    if (!liveSessionService.areHardwareSettingsConfirmed(livestream)) {
        return false;
    }

    if (isHardwareCheckOffline) {
        return true;
    }

    return !sessionReader.isRecordingConnectionEnforced() || livestreamService.isCompleted(livestream);
}

export {
    hardwareCheckIsComplete,
    hardwareCheckIsOffline,
    needsAudio,
    needsHardware,
    needsWebcam,
};
